import React, { useState } from 'react';

export default function UserDetail(props) {
    return <div>User detail</div>;
}
